export const customFieldsQuery = {
  all: ['CustomFields'],
};
